/* eslint-disable @typescript-eslint/no-explicit-any */
export const apiRootUrl: string =
  process.env.NODE_ENV === 'development'
    ? 'https://localhost:5052'
    : (window as any).api_root_url;
export const clientId: string =
  process.env.NODE_ENV === 'development'
    ? 'pmo_local_dev'
    : (window as any).client_id;
export const gaTrackerId: string =
  process.env.NODE_ENV === 'development'
    ? 'UA-178415611-1'
    : (window as any).ga_tracker_id;
